import { takeLatest } from 'redux-saga/effects';
import { fetchEntitySpawn } from 'store/saga';
import URLHelper from './cms.url';
import {
  FETCH_CONTENT_LIST,
  FETCH_CONTENT_DETAILS,
  SAVE_CONTENT_DETAILS,
  PUBLISH_CONTENT_DETAILS,
  fetchContentList,
  fetchContentDetails,
  saveContentDetails,
  publishContentDetails,
} from './cms.actions';
import { REQUEST } from 'utils/actionGenerator';

function* getContentListSaga(action: any) {
  // console.log('action inside saga', action);
  const request = URLHelper.getContentList(action.params);
  yield fetchEntitySpawn(request, fetchContentList, action.params);
}

function* getContentDetailsSaga(action: any) {
  const request = URLHelper.getContentDetails(action.params);
  yield fetchEntitySpawn(request, fetchContentDetails, action.params);
}

function* postSaveContentDetailsSaga(action: any) {
  const request = URLHelper.postSaveContentDetails(action.params);
  yield fetchEntitySpawn(request, saveContentDetails, action.params);
}

function* postPublishContentDetailsSaga(action: any) {
  const request = URLHelper.postPublishContentDetails(action.params);
  yield fetchEntitySpawn(request, publishContentDetails, action.params);
}

function* CmsSaga() {
  yield takeLatest(FETCH_CONTENT_LIST[REQUEST], getContentListSaga);
  yield takeLatest(FETCH_CONTENT_DETAILS[REQUEST], getContentDetailsSaga);
  yield takeLatest(SAVE_CONTENT_DETAILS[REQUEST], postSaveContentDetailsSaga);
  yield takeLatest(PUBLISH_CONTENT_DETAILS[REQUEST], postPublishContentDetailsSaga);
}

export default CmsSaga;
